import { render, staticRenderFns } from "./TaskContainer.vue?vue&type=template&id=41c247af&scoped=true&"
import script from "./TaskContainer.vue?vue&type=script&lang=js&"
export * from "./TaskContainer.vue?vue&type=script&lang=js&"
import style0 from "./TaskContainer.vue?vue&type=style&index=0&id=41c247af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c247af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41c247af')) {
      api.createRecord('41c247af', component.options)
    } else {
      api.reload('41c247af', component.options)
    }
    module.hot.accept("./TaskContainer.vue?vue&type=template&id=41c247af&scoped=true&", function () {
      api.rerender('41c247af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageAgentSub/TaskContainer.vue"
export default component.exports